import { SoundMode } from '../api/klydo';
import { Theme } from '../types';

//TODO: think about the secter key
export const GOOGLE_MAPS_API_KEY = 'AIzaSyC5XG3LtScVeWzLYbiYE-JXY4GLFRnGduQ';
export const DRAWER_WIDTH = 34;
export const APPBAR_HIGHT = 10;
export const DEFAULT_KLYDO_THEME: Theme = {
  handsColor: 'rgba(168, 168, 168, 1)',
  backgroundColor: 'rgba(73, 72, 72, 1)',
  pendulumColor: 'rgba(168, 168, 168, 1)',
  pendulumRodColor: 'rgba(168, 168, 168, 1)',
  dialsColor: 'rgba(217, 217, 217, 1)',
};
export const TUTORIAL_LINK = 'https://youtu.be/wt7AzLL27Xs?si=1Ir2Sm_jvEKtaJxD';

export const MAX_IMAGE_SIZE_BYTES = 10_000_000;
export const MAX_VIDEO_SIZE_BYTES = 70_000_000;

export enum COLLECTION_FOLDER_TYPES {
  COVER = 'cover',
  LOGO = 'logo',
}

export const SOUND_MODE_DISPLAY_TEXT: Record<SoundMode, string> = {
  [SoundMode.OFF]: 'None',
  [SoundMode.ON]: 'Continuous',
  [SoundMode.FIRST_LOOP]: 'Play Once',
};

export const authErrorCodes = new Set([
  'auth/email-already-exists',
  'auth/missing-password',
  'auth/email-already-in-use',
  'auth/invalid-email',
  'auth/invalid-password',
  'auth/wrong-password',
  'auth/weak-password',
  'auth/user-disabled',
  'auth/user-not-found',
  'auth/too-many-requests',
  'auth/invalid-credential',
]);
